import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeEditOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode_edit_outline"}/>
}
